import React, { Fragment } from "react";
import { Link } from "react-router-dom";

import BlueLogo from "./BlueLogo";

const Resubscribe = ({
  profile: { channelid, avatar, firstname, lastname, companyname, location },
}) => {
  return (
    <Fragment>
      <div className="messages-overlay">
        <div className="resubscribe-box">
          <div className="subscription-type-container">
            <p className="nav-logo">
              <BlueLogo />
            </p>
            <h1 className="subscription-name blue">Expired Subscription</h1>
          </div>
          <div className="sub-grid-three">
            <div className="subscription-user">
              <div className="sub-user">
                <div className="online-avi-container">
                  <div className="avi-color-border-alt blue">
                    <img
                      src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                      className="sub-avi"
                      alt="avi"
                    />
                  </div>
                </div>
                <div className="sub-info">
                  <ul className="user-online-items">
                    <li className="user-online-item">
                      <span className="blue name-font bold">{companyname}</span>
                    </li>
                    <li className="user-online-item">
                      {firstname} {lastname}
                    </li>
                    <li className="user-online-item">
                      {location.city}, {location.state}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="sub-grid">
            <p className="resubscribe-request-text">
              Uh-oh! Looks like you don't have an active Employer Subscription.
              Click on the{" "}
              <span className="blue bold large-font">"Resubscribe"</span> button
              below to restore your account.
            </p>
          </div>
          <Link to={`/setupemployers/${channelid}`}>
            <button className="resubscribe-button background-blue bold">
              Resubscribe
            </button>
          </Link>
        </div>
      </div>
    </Fragment>
  );
};

export default Resubscribe;
